import { SquareConnectorsActionTypes } from './constants';

export const squareConnectorsApiResponseSuccess = (actionType, data) => ({
    type: SquareConnectorsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const squareConnectorsApiResponseError = (actionType, error) => ({
    type: SquareConnectorsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const squareConnectorsCreateIntegrationAndStartOAuth = (squareIntegration) => ({
    type: SquareConnectorsActionTypes.CREATE_INTEGRATION_AND_START_OAUTH_REQUEST,
    payload: { squareIntegration },
});
